import { Center } from '@tempmee/react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CANCEL_JOB_ACTION, cancelJob } from '../../../../actions';
import { createSuccessSelector } from '../../../../api/selectors';
import { DotsMenu, MenuItem } from '../../../../commonComponents/DotsMenu';
import useLoading from '../../../../hooks/useLoading';
import { OutlineTrashIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import AnimatedCloseCircle from '../../../shared/AnimatedCloseCircle';
import ConfirmPopup from '../../../shared/ConfirmPopup';

const actions = [CANCEL_JOB_ACTION];
const successSelector = createSuccessSelector(actions);

export const CancelShift = ({ item }) => {
  const dispatch = useDispatch();
  const { isLoading } = useLoading(actions);
  const [showPopup, setShowPopup] = useState(false);
  const removedSuccessfully = useSelector((state) => successSelector(state));

  useEffect(() => {
    if (removedSuccessfully) {
      setShowPopup(false);
    }
  }, [removedSuccessfully, dispatch]);

  return (
    <td>
      <Center width="100%" height="100%">
        <DotsMenu position="bottom">
          <MenuItem
            Icon={() => <OutlineTrashIcon color={colors.neutral[600]} />}
            text={item?.dashboardJobApi?.isOnsiteInterview ? 'Cancel Interview' : 'Cancel Shift'}
            onClick={() => setShowPopup(true)}
          />
        </DotsMenu>
      </Center>

      {showPopup && (
        <ConfirmPopup
          Icon={() => <AnimatedCloseCircle />}
          title="Are you sure you want to cancel?"
          titleStyle={{ marginTop: 20 }}
          description={
            item?.dashboardJobApi?.isOnsiteInterview ? (
              <>
                Are you sure you would like to cancel the onsite interview
                <br />
                for <b>{item?.date}</b>
              </>
            ) : (
              <>
                Are you sure you would like to cancel the shift for
                <br />
                <b>{item?.date}</b>
              </>
            )
          }
          closePopup={(event) => {
            event.stopPropagation();
          }}
          descriptionStyle={{ marginBottom: 50, width: '100%' }}
          leftButtonText="Go Back"
          leftButtonAction={() => setShowPopup(false)}
          rightButtonText={
            item?.dashboardJobApi?.isOnsiteInterview ? 'Cancel Interview' : 'Cancel Shift'
          }
          leftButtonDisabled={isLoading}
          rightButtonDisabled={isLoading}
          rightButtonAction={() => {
            dispatch(cancelJob({ jobId: item?.id }));
          }}
          leftButtonStyle={item?.dashboardJobApi?.isOnsiteInterview ? { width: 180 } : {}}
          rightButtonStyle={item?.dashboardJobApi?.isOnsiteInterview ? { width: 180 } : {}}
        />
      )}
    </td>
  );
};
